module.exports = __webpack_public_path__ + "static/media/saddlebrook-booklet.df057669.pdf";